import React from 'react';
import { Box } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { Button, useToggle } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';

import { ArchivedProviderCard } from './archived-provider.component';
import { useCurrentuser } from '@uplift/contexts';
import { useUserMatchesQuery } from '@uplift/queries';


export const ArchivedProviders: React.VFC = () => {
  const me = useCurrentuser();
  const l10n = useL10n();
  const [ shown, _handleShow, _handleHide, handleToggle ] = useToggle(false);
  const { data } = useUserMatchesQuery(me.id);

  if (!data?.archivedMatches?.length) {
    return null;
  }

  const arrowIcon = shown ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />;
  const toggleLabel = shown
    ? l10n.yourCareTeam.archivedProviders.hide(data?.archivedMatches?.length)
    : l10n.yourCareTeam.archivedProviders.show(data?.archivedMatches?.length);

  return (
    <>
      <Box display="flex" justifyContent="center" width="center">
        <Button onClick={handleToggle} variant="text" endIcon={arrowIcon}>{toggleLabel}</Button>
      </Box>
      {shown && (
        <Box mt={3}>
          {data?.archivedMatches?.map(({ match, provider, providerProfile }) => (
            <ArchivedProviderCard
              key={match.id}
              match={match}
              provider={provider}
              providerProfile={providerProfile}
            />
          ))}
        </Box>
      )}
    </>
  );
};
